import React from 'react';
import {
  Box,
  createStyles,
  LinearProgress,
  Theme,
  withStyles,
} from '@material-ui/core';

import { CloudStatus } from './types';

const StyledLinearProgress = withStyles((theme: Theme) =>
  theme.palette.type === 'dark'
    ? createStyles({
        root: {
          height: '8px',
          borderRadius: theme.shape.borderRadius,
        },
        bar2Buffer: {
          backgroundColor: theme.palette.grey['400'],
        },
        buffer: {
          backgroundColor: '#fff5',
        },
      })
    : createStyles({
        root: {
          height: '8px',
          borderRadius: theme.shape.borderRadius,
        },
      }),
)(LinearProgress);

interface ProgressBarProps {
  done: CloudStatus['done'];
  step: number;
  total: number;
  dataTestId?: string;
  dataTestKey?: string;
}

function ProgressBar({
  done,
  step,
  total,
  dataTestId,
  dataTestKey,
}: ProgressBarProps) {
  const percentVal = (done / total) * 100;
  const buffer = ((done + step) / total) * 100;

  return (
    <Box style={{ margin: '0 0.375rem' }}>
      <StyledLinearProgress
        variant="buffer"
        value={Math.min(percentVal, 100)}
        valueBuffer={Math.min(buffer, 100)}
        data-testid={dataTestId}
        data-test-key={dataTestKey}
      />
    </Box>
  );
}

export default ProgressBar;
